import { UnauthorizedLayout } from './UnauthorizedLayout';

export default UnauthorizedLayout;
